let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e3bmB")).then(() => parcelRequire('9U5fj'));